import React, { useState, forwardRef } from "react";
import { Controller } from "react-hook-form";
import MultiSelectDropdown from "./MultiSelectFilter";
import { IoMdCalendar, IoMdInformationCircleOutline } from "react-icons/io";
import { RxReset } from "react-icons/rx";
import DatePicker from "react-datepicker";
import { FilterButton } from "./FilterButton";
import "react-datepicker/dist/react-datepicker.css";

export function OrderFilters({ control }) {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const statusOptions = [
    { value: "CONFIRMED", label: "Confirmed" },
    { value: "CANCELLED", label: "Cancelled" },
  ];

  // Forwarded Button for DatePicker
  const DateButton = forwardRef(({ value, onClick }, ref) => (
    <FilterButton
      label={value || "Select Date Range"}
      icon={<IoMdCalendar className="w-5 h-5 text-gray-400" />}
      toggleDropdown={() => {
        onClick();
        setIsDatePickerOpen((prev) => !prev);
      }}
      // ref={ref}
      className="flex items-center justify-between gap-2 min-w-[180px] px-4 py-2 bg-white border border-gray-300 rounded-xl text-gray-700 font-medium shadow-sm hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-150"
    />
  ));

  return (
    <div className="flex flex-wrap gap-3">
      {/* Date Range Picker */}
      <Controller
        name="dateRange"
        control={control}
        render={({ field: { onChange, value } }) => (
          <DatePicker
            selected={value?.[0]}
            onChange={(dates) => onChange(dates)}
            startDate={value?.[0]}
            endDate={value?.[1]}
            selectsRange
            open={isDatePickerOpen}
            onClickOutside={() => setIsDatePickerOpen(false)}
            shouldCloseOnSelect={false}
            customInput={
              <DateButton
                value={
                  value?.[0] && value?.[1]
                    ? `${value[0].toLocaleDateString()} - ${value[1].toLocaleDateString()}`
                    : null
                }
              />
            }
            calendarClassName="bg-white shadow-lg rounded-xl border border-gray-200 text-sm"
            popperClassName="bg-white"
            // 👇 Custom container with Reset button pinned to bottom
            calendarContainer={({ className, children }) => (
              <div
                className={`${className} flex flex-col relative bg-white rounded-xl shadow-lg border border-gray-200`}
              >
                <div className="p-3">{children}</div>
                <div className="mt-auto border-t px-3 py-2 flex justify-end bg-gray-50 rounded-b-xl">
                  <button
                    type="button"
                    onClick={() => {
                      onChange([null, null]);
                      setIsDatePickerOpen(false);
                    }}
                    className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100 hover:text-gray-800 hover:border-gray-300 active:scale-[0.98] transition-all duration-150"
                  >
                    <RxReset className="w-4 h-4 text-gray-500" />
                    Reset
                  </button>
                </div>
              </div>
            )}
          />
        )}
      />

      {/* Status Multi-Select */}
      <Controller
        name="status"
        control={control}
        render={({ field }) => (
          <MultiSelectDropdown
            options={statusOptions}
            control={control}
            name={field.name}
            label="Status"
            icon={<IoMdInformationCircleOutline className="w-5 h-5 text-gray-400" />}
            className="flex items-center justify-between gap-2 min-w-[150px] px-4 py-2 bg-white border border-gray-300 rounded-xl text-gray-700 font-medium shadow-sm hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-150"
          />
        )}
      />
    </div>
  );
}